export default __webpack_public_path__ + "static/media/7d.57b366e8.svg";